module.exports = __webpack_public_path__ + "static/media/nd5.7c8d448d.webp";